import { ZillowPropertySearchResponse } from '@aloft/toolkit-shared';

export function getZillowCompRecID(listing: ZillowPropertySearchResponse): string | undefined {
  return listing.zpid ?? undefined;
}
